import { render, staticRenderFns } from "./FatigueDashboard.vue?vue&type=template&id=4ad6acda&"
import script from "./FatigueDashboard.vue?vue&type=script&lang=js&"
export * from "./FatigueDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports